import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";
import { PriceCalculator } from "@/components/PriceCalculator";
import { TablePicker } from "@/components/TablePicker";
import { api, imgUrl } from "@/lib/api";

export default function ProductPage() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/products/${id}`).then((r) => setProduct(r.data)).catch(() => setError(true));
  }, [id]);

  if (error)
    return (
      <div className="mx-auto max-w-7xl px-4 py-24 text-center" data-testid="product-not-found">
        <p className="text-slate-500">Produto não encontrado.</p>
        <Link to="/" className="mt-4 inline-block font-semibold text-sky-600">Voltar aos produtos</Link>
      </div>
    );

  return (
    <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
      <Link to="/" className="mb-6 inline-flex items-center gap-2 text-sm font-semibold text-slate-500 hover:text-sky-600" data-testid="back-to-products">
        <ArrowLeft className="h-4 w-4" /> Produtos
      </Link>
      {!product ? (
        <Skeleton className="h-[480px] rounded-md" />
      ) : (
        <div className="grid grid-cols-1 items-start gap-10 lg:grid-cols-12">
          <div className="reveal space-y-6 lg:col-span-7">
            <img src={imgUrl(product.image_url)} alt={product.name} className="aspect-[4/3] w-full rounded-md object-cover shadow-lg" data-testid="product-image" />
            <div className="space-y-3">
              <p className="text-xs font-bold uppercase tracking-widest text-[#E5007D]">{product.category}</p>
              <h1 className="font-display text-3xl font-extrabold tracking-tight sm:text-4xl" data-testid="product-name">{product.name}</h1>
              <p className="whitespace-pre-line text-base leading-relaxed text-slate-600" data-testid="product-description">{product.description}</p>
            </div>
          </div>
          <div className="reveal lg:sticky lg:top-24 lg:col-span-5" style={{ animationDelay: "120ms" }}>
            {product.price_table ? <TablePicker product={product} /> : <PriceCalculator product={product} />}
          </div>
        </div>
      )}
    </div>
  );
}
